module.exports = __webpack_public_path__ + "img/baroka-fc.3cc9e216.png";